import ResearchSupportLink, { SupportHeart } from './ResearchSupportLink'
import type { SupportSurface } from '@/utils/readerSupport'

export default function ResearchSupportCard({ surface, postSlug, postTopic, compact = false }: {
  surface: SupportSurface
  postSlug?: string
  postTopic?: string
  compact?: boolean
}) {
  return (
    <aside
      aria-label="Support our research"
      className={`not-prose relative overflow-hidden rounded-panel border border-forest/15 bg-cream ${compact ? 'p-5 sm:px-7 sm:py-6' : 'p-6 sm:p-8'}`}
    >
      <div aria-hidden="true" className="absolute inset-y-6 left-0 w-[3px] rounded-r-full bg-forest/60" />
      <div className={`flex flex-col gap-5 ${compact ? 'sm:flex-row sm:items-center sm:justify-between sm:gap-8' : ''}`}>
        <div className="min-w-0 max-w-xl">
          <p className="mb-3 flex items-center gap-2 text-xs font-semibold tracking-wide text-forest">
            <SupportHeart className="h-4 w-4" /> A little support goes a long way
          </p>
          <p className={`font-display font-semibold leading-tight tracking-tight text-ink ${compact ? 'text-xl sm:text-2xl' : 'text-2xl sm:text-[1.875rem]'}`}>
            {compact ? 'Help keep good information within reach.' : 'Useful research. Free for everyone.'}
          </p>
          <p className="mt-3 text-sm leading-relaxed text-gray-600">
            {compact ? 'Your support helps us review sources, update our guides, and keep them free to read.' : 'If this guide helped you make a clearer choice, you can help us keep it going. Your contribution supports reviewing studies, checking product details, and updating our free guides.'}
          </p>
        </div>
        <div className={compact ? 'shrink-0' : 'flex flex-col items-start gap-2 sm:flex-row sm:items-center sm:gap-4'}>
          <ResearchSupportLink surface={surface} postSlug={postSlug} postTopic={postTopic}
            className="w-full bg-forest px-5 py-3 text-white shadow-sm hover:bg-deepForest sm:w-auto">
            <SupportHeart /> Support our research
            <svg aria-hidden="true" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" className="ml-1 h-4 w-4"><path d="M4 10h12M11 5l5 5-5 5" /></svg>
          </ResearchSupportLink>
          <p className={`text-xs leading-relaxed text-gray-600 ${compact ? 'mt-2 sm:text-center' : ''}`}>Give once or monthly</p>
        </div>
      </div>
    </aside>
  )
}
